/**
 * 简易农历转换工具
 * 支持 1900-2100 年
 */

const lunarInfo = [
  0x04bd8,0x04ae0,0x0a570,0x054d5,0x0d260,0x0d950,0x16554,0x056a0,0x09ad0,0x055d2,
  0x04ae0,0x0a5b6,0x0a4d0,0x0d250,0x1d255,0x0b540,0x0d6a0,0x0ada2,0x095b0,0x14977,
  0x04970,0x0a4b0,0x0b4b5,0x06a50,0x06d40,0x1ab54,0x02b60,0x09570,0x052f2,0x04970,
  0x06566,0x0d4a0,0x0ea50,0x06e95,0x05ad0,0x02b60,0x186e3,0x092e0,0x1c8d7,0x0c950,
  0x0d4a0,0x1d8a6,0x0b550,0x056a0,0x1a5b4,0x025d0,0x092d0,0x0d2b2,0x0a950,0x0b557,
  0x06ca0,0x0b550,0x15355,0x04da0,0x0a5d0,0x14573,0x052b0,0x0a9a8,0x0e950,0x06aa0,
  0x0aea6,0x0ab50,0x04b60,0x0aae4,0x0a570,0x05260,0x0f263,0x0d950,0x05b57,0x056a0,
  0x096d0,0x04dd5,0x04ad0,0x0a4d0,0x0d4d4,0x0d250,0x0d558,0x0b540,0x0b6a0,0x195a6,
  0x095b0,0x049b0,0x0a974,0x0a4b0,0x0b27a,0x06a50,0x06d40,0x0af46,0x0ab60,0x09570,
  0x04af5,0x04970,0x064b0,0x074a3,0x0ea50,0x06aa0,0x0a6b6,0x056a0,0x02b60,0x09570,
  0x052b2,0x0a950,0x0e952,0x06aa0,0x0ad50,0x0cd4a,0x02b60,0x09570,0x052b2,0x0a950,
  0x0b557,0x06ca0,0x0b550,0x15355,0x04da0,0x0a5b0,0x14573,0x052b0,0x0a9a8,0x0e950,
  0x06aa0,0x0aea6,0x0ab50,0x04b60,0x0aae4,0x0a570,0x05260,0x0f263,0x0d950,0x05b57,
  0x056a0,0x096d0,0x04dd5,0x04ad0,0x0a4d0,0x0d4d4,0x0d250,0x0d558,0x0b540,0x0b6a0,
  0x195a6,0x095b0,0x049b0,0x0a974,0x0a4b0,0x0b27a,0x06a50,0x06d40,0x0af46,0x0ab60,
  0x09570,0x04af5,0x04970,0x064b0,0x074a3,0x0ea50,0x06aa0,0x0a6b6,0x056a0,0x02b60,
  0x09570,0x052b2,0x0a950,0x0e952,0x06aa0,0x0ad50,0x0cd4a,0x02b60,0x093b0,0x18da9,
  0x0a950,0x0b4a8,0x0b550,0x06ca0,0x0d5a9,0x04da0,0x0a5b0,0x15b45,0x052b0,0x0a930,
  0x07954,0x06aa0,0x0ad50,0x05b52,0x04b60,0x0a6e6,0x0a4e0,0x0d260,0x0ea65,0x0d530,
  0x05aa0,0x076a3,0x096d0,0x04afb,0x04ad0,0x0a4d0,0x1d0b6,0x0d250,0x0d520,0x0dd45,
];

const Gan = ["甲","乙","丙","丁","戊","己","庚","辛","壬","癸"];
const Zhi = ["子","丑","寅","卯","辰","巳","午","未","申","酉","戌","亥"];
const lunarMonthName = ["正","二","三","四","五","六","七","八","九","十","冬","腊"];
const lunarDayName = [
  "初一","初二","初三","初四","初五","初六","初七","初八","初九","初十",
  "十一","十二","十三","十四","十五","十六","十七","十八","十九","二十",
  "廿一","廿二","廿三","廿四","廿五","廿六","廿七","廿八","廿九","三十"
];

function leapMonth(y: number): number {
  return lunarInfo[y - 1900] & 0xf;
}
function leapDays(y: number): number {
  if (leapMonth(y)) {
    return (lunarInfo[y - 1900] & 0x10000) ? 30 : 29;
  }
  return 0;
}
function monthDays(y: number, m: number): number {
  return (lunarInfo[y - 1900] & (0x10000 >> m)) ? 30 : 29;
}

export interface LunarDate {
  year: number;
  month: number;
  day: number;
  isLeap: boolean;
  yearGanZhi: string;
  monthStr: string;
  dayStr: string;
}

export function solarToLunar(sYear: number, sMonth: number, sDay: number): LunarDate {
  const baseDate = new Date(1900, 0, 31);
  const objDate = new Date(sYear, sMonth - 1, sDay);
  let offset = Math.round((objDate.getTime() - baseDate.getTime()) / 86400000);

  let lYear = 1900;
  let lMonth = 1;
  let lDay = 1;
  let isLeap = false;

  let i = 1900;
  for (; i < 2101 && offset > 0; i++) {
    let daysInYear = 348;
    for (let j = 0x8000; j > 0x8; j >>= 1) {
      daysInYear += (lunarInfo[i - 1900] & j) ? 1 : 0;
    }
    daysInYear += leapDays(i);
    offset -= daysInYear;
  }
  if (offset < 0) {
    offset += (i === 1900 ? 348 : (() => {
      let d = 348;
      for (let j = 0x8000; j > 0x8; j >>= 1) d += (lunarInfo[i - 1 - 1900] & j) ? 1 : 0;
      d += leapDays(i - 1);
      return d;
    })());
    i--;
  }
  lYear = i;

  const leap = leapMonth(lYear);
  let leapFlag = false;

  for (let j = 1; j < 13 && offset > 0; j++) {
    if (leap > 0 && j === leap + 1 && !leapFlag) {
      j--;
      leapFlag = true;
      const ld = leapDays(lYear);
      offset -= ld;
    } else {
      offset -= monthDays(lYear, j);
    }
    if (leapFlag && j === leap + 1) leapFlag = false;
    if (offset === 0 && leap > 0 && j === leap) {
      if (leapFlag) { leapFlag = false; } else { leapFlag = true; j--; }
    }
    if (offset < 0) {
      offset += leapFlag ? leapDays(lYear) : monthDays(lYear, j);
      j--;
      if (leapFlag) leapFlag = false;
      lMonth = j;
      lDay = offset + 1;
      break;
    }
    lMonth = j;
    lDay = offset + 1;
  }

  isLeap = leapFlag;

  const ganIdx = (lYear - 4) % 10;
  const zhiIdx = (lYear - 4) % 12;
  const yearGanZhi = Gan[(ganIdx + 10) % 10] + Zhi[(zhiIdx + 12) % 12] + "年";

  return {
    year: lYear,
    month: lMonth,
    day: lDay,
    isLeap,
    yearGanZhi,
    monthStr: (isLeap ? "闰" : "") + lunarMonthName[lMonth - 1] + "月",
    dayStr: lunarDayName[lDay - 1],
  };
}

export const LUNAR_MONTH_NAMES = lunarMonthName;
export const LUNAR_DAY_NAMES = lunarDayName;

// 时辰列表
export const SHICHEN_LIST = [
  { label: "00:00-00:59子时", value: "00:00-00:59子时" },
  { label: "01:00-01:59丑时", value: "01:00-01:59丑时" },
  { label: "02:00-02:59丑时", value: "02:00-02:59丑时" },
  { label: "03:00-03:59寅时", value: "03:00-03:59寅时" },
  { label: "04:00-04:59寅时", value: "04:00-04:59寅时" },
  { label: "05:00-05:59卯时", value: "05:00-05:59卯时" },
  { label: "06:00-06:59卯时", value: "06:00-06:59卯时" },
  { label: "07:00-07:59辰时", value: "07:00-07:59辰时" },
  { label: "08:00-08:59辰时", value: "08:00-08:59辰时" },
  { label: "09:00-09:59巳时", value: "09:00-09:59巳时" },
  { label: "10:00-10:59巳时", value: "10:00-10:59巳时" },
  { label: "11:00-11:59午时", value: "11:00-11:59午时" },
  { label: "12:00-12:59午时", value: "12:00-12:59午时" },
  { label: "13:00-13:59未时", value: "13:00-13:59未时" },
  { label: "14:00-14:59未时", value: "14:00-14:59未时" },
  { label: "15:00-15:59申时", value: "15:00-15:59申时" },
  { label: "16:00-16:59申时", value: "16:00-16:59申时" },
  { label: "17:00-17:59酉时", value: "17:00-17:59酉时" },
  { label: "18:00-18:59酉时", value: "18:00-18:59酉时" },
  { label: "19:00-19:59戌时", value: "19:00-19:59戌时" },
  { label: "20:00-20:59戌时", value: "20:00-20:59戌时" },
  { label: "21:00-21:59亥时", value: "21:00-21:59亥时" },
  { label: "22:00-22:59亥时", value: "22:00-22:59亥时" },
  { label: "23:00-23:59子时", value: "23:00-23:59子时" },
];
